module.exports = __webpack_public_path__ + "static/media/Tanzania-Queen-and-Son-small-tablet.c95661d8.jpg";